import { isSettingsRecurrenceEnabled } from '@/actions-permission/settings.permissions'

const routeRecurrence = store => ({
  path: 'recurrence',
  name: 'recurrence',
  component: () =>
    import(
      /* webpackChunkName: "recurrence" */ '@/views/Settings/Recurrence.vue'
    ),
  beforeEnter: (to, from, next) => {
    if (!isSettingsRecurrenceEnabled(store.getters.permissionIsEnabled)) {
      return store.commit('toggleGlobalError', { status: true, code: 404 })
    }
    next()
  },
  meta: {
    breadcrumb: {
      refer: 'breadcrumb.settings.root',
      current: 'breadcrumb.settings.recurrence'
    }
  }
})

export default routeRecurrence
